module.exports = __webpack_public_path__ + "images/icons/icon-step-address-dba7b8e3.svg";